import axios from 'axios'

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api'

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      localStorage.removeItem('sessionToken')
      window.location.href = '/signin'
    }
    return Promise.reject(error)
  }
)

export const intentAPI = {
  // Get all intents
  getIntents: () => {
    console.log('IntentAPI: Get intents request')
    return api.get('/api/intent')
  },

  // Get intent by ID
  getIntentById: (id) => {
    console.log('IntentAPI: Get intent by ID request:', id)
    return api.get(`/api/intent/${id}`)
  },

  // Create new intent
  createIntent: (intentData) => {
    console.log('IntentAPI: Create intent request:', intentData)
    return api.post('/api/intent', intentData)
  },

  // Update intent
  updateIntent: (id, intentData) => {
    console.log('IntentAPI: Update intent request:', id, intentData)
    return api.put(`/api/intent/${id}`, intentData)
  },

  // Delete intent
  deleteIntent: (id) => {
    console.log('IntentAPI: Delete intent request:', id)
    return api.delete(`/api/intent/${id}`)
  }
}

export default intentAPI
